module.exports = __webpack_public_path__ + "img/pg5-article-text4.a9bc0946.png";